import axios from './index'
import prefix_ms from './prefix'

//获取团购商品信息
export const groupBuyGoodsInfo = (params) => {
    return axios.request({
      url: `${prefix_ms}/groupBuyGoods/info`,
      method: 'get',
      params: params,
    })
  }

// 获取展示的团购商品
export const groupBuyGoodsShow = () => {
    return axios.request({
      url: `${prefix_ms}/groupBuyGoods/goodsShowInfo`,
      method: 'get',
    })
}

//微信团购下单
export const weixincreate = (params) => {
    return axios.request({
      url: `${prefix_ms}/groupBuyOrder/weixin/create`,
      method: 'post',
      data: params,
    })
}

//我的购买
export const groupBuyOrderpaid = (params) => {
    return axios.request({
      url: `${prefix_ms}/groupBuyOrder/list/paid`,
      method: 'post',
      params: params,
    })
}

// 家长充值记录
export const postParentPaid = (params) => {
    return axios.request({
      url: prefix_ms + `/groupBuyOrder/list/parent/paid`,
      method: 'get',
      params: params,
    })
  }




//////////////////
// WEBPACK FOOTER
// ./app/api/groupbuy.js
// module id = null
// module chunks = 